"use strict";
const srsEUR6PalletArticle = {
    articleNumber: '5004',
    salesPrice: 200,
    purchasePrice: 200,
    name: 'SRS pant',
    shortName: 'SRS pant',
    active: true,
    onCopack: true,
    colliSize: 1,
    utilityArticle: true,
    owningSupplierOrganizationId: null,
};
const pantArticleLow = {
    articleNumber: '3146',
    name: 'Pant (12% moms)',
    shortName: 'Pant (12% moms)',
    salesPrice: 0.89,
    purchasePrice: 0.89,
    VAT: 12,
    onCopack: true,
    active: true,
    purchaseAccount: 4112,
    salesAccount: 3312,
    colliSize: 1,
    utilityArticle: true,
    owningSupplierOrganizationId: null,
};
const pantArticleHigh = {
    articleNumber: '1915',
    name: 'Pant (25% moms)',
    shortName: 'Pant (25% moms)',
    salesPrice: 0.8,
    purchasePrice: 0.8,
    VAT: 25,
    onCopack: true,
    active: true,
    purchaseAccount: 4112,
    salesAccount: 3311,
    colliSize: 1,
    utilityArticle: true,
    owningSupplierOrganizationId: null,
};
const alcTaxArticle = {
    articleNumber: '5000',
    name: 'Alkoholskatt',
    shortName: 'Alkoholskatt',
    onCopack: true,
    active: true,
    purchaseAccount: 4990,
    salesAccount: 3991,
    colliSize: 1,
    utilityArticle: true,
    owningSupplierOrganizationId: null,
};
const handlingCostArticle = {
    articleNumber: '5002',
    name: 'Plock- och pallkostnad',
    shortName: 'Plock- och pallkostnad',
    onCopack: true,
    active: true,
    purchaseAccount: 4110,
    salesAccount: 3520,
    VAT: 25,
    colliSize: 1,
    utilityArticle: true,
    owningSupplierOrganizationId: null,
};
const freightCostArticle = {
    articleNumber: '5003',
    onCopack: true,
    name: 'Fraktkostnad',
    shortName: 'Fraktkostnad',
    active: true,
    purchaseAccount: 4015,
    salesAccount: 3520,
    VAT: 25,
    colliSize: 1,
    utilityArticle: true,
    owningSupplierOrganizationId: null,
};
const serviceFeeForOwnInvoicingArticle = {
    articleNumber: '5050',
    onCopack: true,
    name: 'Serviceavgift för varor fakturerade av leverantör',
    shortName: 'Serviceavgift för varor fakturerade av leverantör',
    active: true,
    purchaseAccount: 4021,
    salesAccount: 3400,
    colliSize: 1,
    utilityArticle: true,
    owningSupplierOrganizationId: null,
};
const allSpecialArticles = [
    pantArticleLow,
    pantArticleHigh,
    alcTaxArticle,
    srsEUR6PalletArticle,
    handlingCostArticle,
    freightCostArticle,
    serviceFeeForOwnInvoicingArticle,
];
const isSpecialArticle = article => allSpecialArticles.some(a => a.articleNumber === article.articleNumber &&
    article.owningSupplierOrganizationId === null);
module.exports = {
    pantArticleLow,
    pantArticleHigh,
    alcTaxArticle,
    srsEUR6PalletArticle,
    handlingCostArticle,
    freightCostArticle,
    serviceFeeForOwnInvoicingArticle,
    allSpecialArticles,
    isSpecialArticle,
};
